import { defineAsyncComponent } from "vue";
import { createRouter, createWebHistory } from "vue-router";

import home from "./Component/Page/Home.vue";

const aboutUs = defineAsyncComponent(() => import("./Component/Page/AboutUs.vue"));
const medicinal = defineAsyncComponent(() => import("./Component/Page/Medicinal.vue"));
const benefit = defineAsyncComponent(() => import("./Component/Page/Benefit.vue"));
const detect = defineAsyncComponent(() => import("./Component/Page/Detect.vue"));
const weblog = defineAsyncComponent(() => import("./Component/Page/Weblog.vue"));
const product = defineAsyncComponent(() => import("./Component/Page/Product.vue"));
const contactUs = defineAsyncComponent(() => import("./Component/Page/ContactUs.vue"));
const producePage = defineAsyncComponent(() => import("./Component/Page/ProducePage.vue"));

let router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/home", component: home },
    { path: "/aboutUs", component: aboutUs },
    { path: "/medicinal", component: medicinal },
    { path: "/benefit", component: benefit },
    { path: "/produce", component: producePage },
    { path: "/detect", component: detect },
    { path: "/weblog", component: weblog },
    { path: "/product", component: product },
    { path: "/contactUs", component: contactUs },
    { path: "/:notFound(.*)", redirect: "/home" }

  ],
});

export default router;
